import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login";
import Layout from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import NewPass from "./pages/NewPass";
import History from "./pages/History";
import Talmidim from "./pages/Talmidim";
import Reports from "./pages/Reports";
import Attendance from "./pages/Attendance";
import PassPrint from "./pages/PassPrint";
import Settings from "./pages/Settings";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { PassesProvider } from "./context/PassesContext";
import { TalmidimProvider } from "./context/TalmidimContext";
import { SettingsProvider } from "./context/SettingsContext";
import { AbsencesProvider } from "./context/AbsencesContext";
import { Toaster } from "./components/ui/toaster";
import InstallAppButton from "./components/InstallAppButton";
import { Loader2 } from "lucide-react";

function LayoutRoutes({ onLogout }) {
  return (
    <Layout onLogout={onLogout}>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/new-pass" element={<NewPass />} />
        <Route path="/history" element={<History />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/attendance" element={<Attendance />} />
        <Route path="/talmidim" element={<Talmidim />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Layout>
  );
}

function AuthedApp() {
  const { user, loading, logout } = useAuth();

  useEffect(() => {
    if (localStorage.getItem("oht_authed") === "1") {
      localStorage.removeItem("oht_authed");
    }
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <Loader2 className="w-8 h-8 animate-spin text-blue-600" />
      </div>
    );
  }

  const authed = !!user;

  if (!authed) {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      </BrowserRouter>
    );
  }

  // Authenticated: wrap ALL routes (including /print/:passId) in providers
  return (
    <SettingsProvider>
      <TalmidimProvider>
        <PassesProvider>
          <AbsencesProvider>
            <BrowserRouter>
              <Routes>
                <Route path="/login" element={<Navigate to="/" />} />
                <Route path="/print/:passId" element={<PassPrint />} />
                <Route path="/*" element={<LayoutRoutes onLogout={logout} />} />
              </Routes>
            </BrowserRouter>
          </AbsencesProvider>
        </PassesProvider>
      </TalmidimProvider>
    </SettingsProvider>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <AuthedApp />
      </AuthProvider>
      <Toaster />
      <InstallAppButton />
    </div>
  );
}

export default App;
